export default __webpack_public_path__ + "static/media/impressions-6.2ad66cb3.png";